const LIGHT_DUTY_STATUSES_DICT = {
  full_duty: 'Full Duty',
  off_work_auth: 'Declined',
  light_duty: 'Light Duty',
  wc_leave: 'WC Leave',
} as const;

export default LIGHT_DUTY_STATUSES_DICT;
